module.exports = __webpack_public_path__ + "img/360-multiop-old.9ad22e85.jpg";